import { render, staticRenderFns } from "./ColorKitHighlightsCTA.vue?vue&type=template&id=02cc0f42&scoped=true&lang=pug&"
import script from "./ColorKitHighlightsCTA.vue?vue&type=script&lang=js&"
export * from "./ColorKitHighlightsCTA.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitHighlightsCTA.vue?vue&type=style&index=0&id=02cc0f42&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc0f42",
  null
  
)

export default component.exports